import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

export const tenantGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isPlatformAdmin()) {
    return router.createUrlTree(['/platform/tenants']);
  }

  if (authStore.tenant()) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
